// TODO rename to "utils"
window.app.factory("$utils", [
  "$q",
  "$sce",
  "$sanitize",
  "$rootScope",
  function($q, $sce, $sanitize, $rootScope) {
    return function($scope, debug) {
      return {
        race,
        all,
        broadcast,
        firstKey,
        hSize,
        getSanitizedHTML,
        fixLocalLinks,
        withRetries
      };

      function withRetries(f, retries = 2, delay = 0) {
        return (...args) => {
          return $q((resolve, reject) => {
            let attempts = retries + 1;
            const tryit = () => {
              f(...args).then(
                res => {
                  resolve(res);
                },
                err => {
                  if (--attempts) {
                    setTimeout(tryit, delay);
                  } else {
                    console.error(
                      `Function still failing after ${retries} retries`,
                      { f, retries, delay }
                    );
                    reject(err);
                  }
                }
              );
            };
            tryit();
          });
        };
      }

      function hSize(bytes) {
        const n = Math.min(4, Math.floor(Math.log10(bytes) / 3));
        let v = bytes / Math.pow(1000, n);
        v = v < 100 ? Math.round(v * 10) / 10 : Math.round(v);
        return v + " " + ["B", "KB", "MB", "GB"][n];
      }

      function race() {
        var args = Array.prototype.slice.call(arguments);
        return $q(function(resolve, reject) {
          args.forEach(function(promise) {
            promise && promise.finally(resolveFirst);
          });

          var resolved = false;

          function resolveFirst(value) {
            if (!resolved) {
              resolve(value);
            }
            resolved = true;
          }
        });
      }

      function all() {
        var args = Array.prototype.slice.call(arguments).filter(function(arg) {
          return arg && arg.then;
        });
        return $q(function(resolve, reject) {
          var count = args.length;
          args.forEach(function(arg) {
            arg.then(function(result) {
              --count == 0 && resolve(result);
            });
          });
        });
      }

      function broadcast(a, cb) {
        window.requestAnimationFrame(function() {
          debug && console.log("broadcast", a);
          $scope.$broadcast(a);
          cb && cb();
        });
      }

      function firstKey(obj) {
        for (var key in obj) {
          return key;
        }
      }

      function getSanitizedHTML(html) {
        // Workaround to sanitize keeping style attributes
        html = html.replace(/style="/g, 'class="STYLE:');
        const sanitized = $sanitize(html).replace(/class="STYLE:/g, 'style="');
        return $sce.trustAsHtml(sanitized);
      }

      function fixLocalLinks(html, baseUrl) {
        baseUrl = baseUrl || $rootScope.enterpriseConfig.frontEndUrl;
        let regex = baseUrl.replace(
          /https?:\/\/(.+)\/?/,
          "href=[\"']https?://$1/?(#[^'\"]+)['\"]"
        );
        console.warn("=== BASEURL (FE)", baseUrl);
        console.warn("=== REGEX", regex);
        return html.replace(RegExp(regex, "g"), 'href="$1"');
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/services/utils.js